import * as sentry from '../../src/utils/sentry'
import { DS_getData } from '../DS/DS.Data'

export function Logg_event(eventName: string, properties?: any) {
    try {
        const { customer, user, appCenterMetricsDisabled } = DS_getData()

        // Print only the specific properties to the console
        /* eslint-disable-next-line no-console */
        console.log(eventName, JSON.stringify(properties))

        // Only log in production
        if (!ENV.isProduction) return

        // AppCenter logging is only for cordova
        if (window.AppCenter == null) return

        // Ignore if disabled
        if (appCenterMetricsDisabled) return

        // Ignore if on cellular network
        if (
            navigator.connection.type === Connection.CELL_2G ||
            navigator.connection.type === Connection.CELL_3G ||
            navigator.connection.type === Connection.CELL_4G ||
            navigator.connection.type === Connection.CELL
        ) {
            return
        }

        // Ignore if zaptic staff
        if (user && user.zapticStaff) return

        // Ignore if on test server
        if (customer && customer.name === 'Test Server') return

        // Add customer to properties
        if (customer != null) {
            properties = { customerName: customer.name, ...properties }
        }

        // Normalize values
        for (const key in properties) {
            // Do not want nulls as it will throw
            if (properties[key] == null) {
                properties[key] = 'null'
            }
        }

        // This is limited to:
        //   200 eventNames
        //   20 properties per event
        //   256 characters per eventName
        //   125 characters per property name
        //   125 characters per property value
        window.AppCenter.Analytics.trackEvent(
            eventName,
            properties,
            () => null,
            (error) => sentry.err(error, {})
        )
    } catch (error) {
        sentry.err(error, {})
    }
}
